/**
 * author: Ananthapadmanabhan
 */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
  BiGitMerge,
  BiPencil,
  BiTrash,
  BiPlus,
  BiDotsHorizontalRounded,
  BiChevronDown,
} from "react-icons/bi";
import { OverlayTrigger, Dropdown, Collapse, Breadcrumb, Modal, Button } from "react-bootstrap";
import Utils from "../../../../core/utilities/Utils";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import ConfirmationModal from "../../../../components/ConfirmationModal/ConfirmationModal";

import StandardService from "../../../../core/service/StandardService";

import "./TopicsAdmin.scss";
import { useNavigate, useParams } from "react-router-dom";
import AddTopic from "../AddTopic/AddTopic";
import ConfirmDialog from '../../../../core/utilities/ConfirmPopup';
import { toast } from "react-toastify";
import PermissionUtils from "../../../../core/utilities/PermissisonUtils";

function TopicsAdmin({ t }) {
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [messageConfirmation, setMessageConfirmation] = useState("");
  const [confirmId, setConfirmId] = useState("");
  let lsData = JSON.parse(localStorage.getItem("authority"));
  const [socialtabledata, setSocialTableData] = useState([]);
  const [environmenttabledata, setEnvironmentTableData] = useState([]);
  const [governancetabledata, setGovernanceTableData] = useState([]);
  const [categorydata, setCategoryData] = useState([]);
  const [dsList, setDsList] = useState([]);
  const [shown, setShown] = useState(false);
  const [currentDs, setCurrentDs] = useState([]);
  const [data, setData] = useState([]);
  const categoryType = '';
  const { std_id } = useParams();
  const navigate = useNavigate();
  const [editTopicId, setEditTopicId] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [isCompanyAdmin, setIsCompanyAdmin] = useState(true);
  // const [list, setList] = useState(listObj);
  // var isCompanyAdmin = true;

  useEffect(() => {
    var lsCategory = localStorage.getItem('categoryName');
    if (lsCategory != null && lsCategory != undefined && lsCategory != '') {
      handleExpand(lsCategory);
    }
    var lsDat = JSON.parse(localStorage.getItem('authority'));
    if (PermissionUtils.isSuperAdmin(lsDat.roles)) {
      setIsCompanyAdmin(false);
    }else{
      setIsCompanyAdmin(true);
    }
  
    getCategory();
    getTopics(std_id)
  }, [])

  const getTopics = (stdid) => {
    StandardService.getTopics(stdid)
      .then((response) => {
        // setList(response?.data);
        const topics = response?.data?.topics;
        filterCategoryData(topics);
        if (Array.isArray(topics)) {
          setData([...topics]);
        } else {
          setData([]);
        }

      })
      .catch((error) => { });
  };

  const handleExpandDs = (e, categoryType) => {
    setDsList([]);
    setCurrentDs([]);
    //setSelDataSource(id);

    const newVal = !shown[categoryType];
    if (newVal) {
      let obj = { categoryType: categoryType };
      setCurrentDs([...currentDs, obj]);
    }
    setShown({
      [categoryType]: !shown[categoryType],
    });

    //  setIsExpanded(true);
  };

  const getCategory = async (e) => {
    StandardService.getCategory(std_id)
      .then((response) => {
        let socialArray = [];
        socialArray = response.data.filter(x => x.categoryType === "SOCIAL");
        let environmentArray = [];
        environmentArray = response.data.filter(x => x.categoryType === "ENVIRONMENTAL");
        let governanceArray = [];
        governanceArray = response.data.filter(x => x.categoryType === "GOVERNANCE");
        var mainData = [];
        for (let i = 0; i < response.data.length; i++) {
          if (response.data.categoryType === "SOCIAL") {
            response.data[i].topicCount = socialArray.length;
          } else if (response.data.categoryType === "ENVIRONMENTAL") {
            response.data[i].topicCount = environmentArray.length;
          } else {
            response.data[i].topicCount = governanceArray.length;
          };
          // response.data[i].topicCount=0;
          mainData.push(response.data[i])
        }
        setCategoryData([...mainData]);
        // filterCategoryData()
      })
      .catch((error) => { });
  };

  const filterCategoryData = (datas) => {
    // console.log('datadata', data)
    let arrayDP = datas;
    let socialArray = [];
    socialArray = datas.filter(x => x.categoryType === "SOCIAL");
    let environmentArray = [];
    environmentArray = datas.filter(x => x.categoryType === "ENVIRONMENTAL");
    let governanceArray = [];
    governanceArray = datas.filter(x => x.categoryType === "GOVERNANCE");
    setSocialTableData([...socialArray]);
    setEnvironmentTableData([...environmentArray]);
    setGovernanceTableData([...governanceArray]);

    var categoryObj = [{
      category: 'SOCIAL',
      arrayLength: socialArray.length
    },
    {
      category: 'ENVIRONMENTAL',
      arrayLength: environmentArray.length
    },
    {
      category: 'GOVERNANCE',
      arrayLength: governanceArray.length
    }];
    // handleCount(categoryObj);
  }

  // const getTableData = (category) => {
  //   console.log('category', category,governancetabledata)
  //   switch (category) {
  //     case 'SOCIAL': return socialtabledata
  //       break;
  //     case 'ENVIRONMENTAL': return environmenttabledata
  //       break;
  //     case 'GOVERNANCE': return governancetabledata
  //       break;
  //     default:
  //       break;
  //   }
  // }


  const getTableData = (item) => {
    switch (item.categoryType) {
      case 'SOCIAL': item.topicCount = socialtabledata.length
        return socialtabledata
      case 'ENVIRONMENTAL':
        item.topicCount = environmenttabledata.length
        return environmenttabledata
      case 'GOVERNANCE':
        item.topicCount = governancetabledata.length
        return governancetabledata
      default:
        break;
    }
  }


  const gotoMetric = (name, id, category) => {
    localStorage.setItem('categoryName', category);
    localStorage.setItem('topicName', name);
    var url = '';
    if (isCompanyAdmin) {
      url = '/company_admin/metriclist/' + std_id + '/' + id;
    } else {
      url = '/admin/metriclist/' + std_id + '/' + id;
    }
    // var url = '/company_admin/metriclist/' + std_id + '/' + id;
    navigate(url);
  };
  const deleteTopic = (item) => {
    setConfirmId(1); // delete parameter
    // if (item.children && item.children.length > 0) {
    //   setMessageConfirmation(t("ConfirmDeleteParentStandardMsg.label"));
    // } else {
    //   setMessageConfirmation(t("ConfirmDeleteTopicMsg.label"));
    // }
    setConfirmOpen(true);
    setDeleteId(item.id);

  };

  const deletConfirm = () => {
    StandardService.deleteTopic(std_id, deleteId)
      .then((response) => {
        if (response.status === 204) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getTopics(std_id);
        }
      })
      .catch((error) => { });
  };


  const handleCallbackonfirmation = (val, id) => {
    setShow(false);
    if (id === 1) {
      // val && handleDeleteCallback(sId, deleteId, "TOPIC");
    }
  };
  const editTopic = (item) => {
    setEditTopicId(item.id);
    handleShow(item.categoryType);
    // let obj = {
    //   val: true,
    //   type: "TOPIC",
    //   id: id,
    //   stdId: stdid
    // };
    // handleEditTopicCallback(obj);
  };
  const breadCrumbClick = (url) => {
    var urlMain = '';
    if (isCompanyAdmin) {
      urlMain = '/company_admin' + url
    } else {
      urlMain = '/admin' + url
    }
    navigate(urlMain);
  }

  const handleClose = () => setShow(false);
  const handleShow = (category) => {
    localStorage.setItem('categoryName', category);
    setShow(true)
  };
  const handleAfterSave = () => {
    getTopics(std_id);
    handleClose();
    // setShowMetric(false);
  };

  const handleExpand = (id) => {
    const newVal = !shown[id];
    var obj = function (shown) {
      Object.keys(shown).forEach(function (key) {
        shown[key] = false;
      });
      return shown;
    };
    setShown({
      ...obj,
      [id]: newVal,
    });
    localStorage.setItem('categoryName', '')
  }
  return (

    <>

      <div className="List_header pb-2">
        <h5 className="MH m-0">{t("Configurations.label")}</h5>
      </div>

      {/* <div className="List_header pb-2"><h5 className="MH m-0">Configurations</h5></div> */}
      <div className="Topics_headeView">
        <ul>
          <li>
            Standard : <b>{localStorage.getItem('standardName')}</b>
          </li>
        </ul>
        <div className="btn-custom p-1 text-end">
          <button
            className="btn btn-secondary"
            onClick={() => breadCrumbClick('/standard')}
          >
            {t("Back.label")}
          </button>
        </div>
      </div>
      {categorydata.length > 0 && categorydata?.map((mainitem) => (<div className="TopicsAdmin RSW_Add_Card_row01 mb-1">
        <>

          <div className="card StandardsSub_Topics_Card">
            <div className="card-body p-0">
              <div className="SST_CardBox">
                <div className="SST_CardBox_head">
                  <div className="expand_RswBox 1">
                    <BiChevronDown
                      onClick={(e) => handleExpand(mainitem.categoryType)}
                      aria-controls="example-collapse-text"
                    ></BiChevronDown>
                  </div>
                  <div className="SST_view_data d-flex">
                    <h6 className="mb-0 me-2" >{mainitem.categoryType}</h6>
                    <span><strong>
                      {mainitem.topicCount ? mainitem.topicCount : 0}
                    </strong> <BiGitMerge /></span>
                  </div>
                </div>
                <Collapse in={shown[mainitem.categoryType]}>
                  <div className="Sub_Top_ViewCard">
                    {getTableData(mainitem)?.map((item) => (
                      <div className="row m-0">
                        <div className="col-lg-8 p-0">
                          <div className="card Sub_Top_ViewCard_inner" key={item.id}>
                            <div className="card-body p-2">
                              <div className="row m-0 pe-5">
                                <div className="col-lg-10 p-1">
                                  <h6 className="mb-0 me-2">{item.name}</h6>
                                </div>
                                <div className="col-lg-2 p-1">

                                  <h6
                                    className="mb-0 cursor"

                                  >
                                    <span onClick={() => gotoMetric(item.name, item.id, mainitem.categoryType)}>
                                      {item.childrenCount ? item.childrenCount : 0}
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={Utils.renderTooltip(
                                          t("ViewMetrics.label")
                                        )}
                                      >
                                        <span className="ms-1">
                                          <BiGitMerge
                                            onClick={() => gotoMetric(item.name, item.id, mainitem.categoryType)}
                                          />
                                        </span>
                                      </OverlayTrigger>
                                    </span>
                                  </h6>

                                </div>

                              </div>
                              <div className="edit_btn-absolute">
                                {
                                  item.mandatory === true ? (
                                  ""
                                ) : (
                                  <Dropdown>
                                    <Dropdown.Toggle variant="blank_outline" id="dropdown-basic">
                                      <BiDotsHorizontalRounded />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        href="#"
                                        onClick={() => editTopic(item)}
                                      >
                                        <BiPencil className="me-2"/> {t("Edit.label")}
                                      </Dropdown.Item>

                                      <Dropdown.Item onClick={() => deleteTopic(item)} >
                                        <BiTrash className="me-2"/> {t("Delete.label")}
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="col-lg-12 p-1">
                      <button className="btn btn-primary me-2" onClick={() => {
                        setEditTopicId(null);
                        handleShow(mainitem.categoryType)
                      }
                      }>
                        <BiPlus className="me-2"> </BiPlus>
                        {t("Topic.label")}
                      </button>
                      {/* <button className="btn btn-secondary" >
                        <BiPlus className="me-2"> </BiPlus>
                        {t("Topic.label")}
                      </button> */}
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </div>

          {/* )} */}
          {/* {show && (
            <ConfirmationModal
              modalShow={true}
              messageText={messageConfirmation}
              callbackModal={handleCallbackonfirmation}
              id={confirmId}
              confirmBtn={t("Yes.label")}
              CancelBtn={t("No.label")}
            />
          )} */}
        </>
      </div>))}

      <Modal show={show} onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {/* <Modal.Header closeButton>
          < Modal.Title as="h5">Modal heading</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>

          <AddTopic
            stdId={std_id}
            handleDiscard={handleClose}
            editTopicId={editTopicId}
            handleSave={handleAfterSave}
            currentcategory={localStorage.getItem('categoryName')}
          />
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary">Understood</Button>
        </Modal.Footer> */}

      </Modal>

      {deleteId && <ConfirmDialog
        open={confirmOpen}
        setOpen={setConfirmOpen}
        onConfirm={deletConfirm}                        >
        <div className='text-center'>{t("ConfirmDelete.label")}</div>
      </ConfirmDialog>}

    </>
  );
}
export default withTranslation()(TopicsAdmin);
